var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12.25px",
    height: "12.25px",
    viewBox: "36.875 16.875 12.25 12.25",
    enableBackground: "new 36.875 16.875 12.25 12.25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.729,17.021c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707L42.293,23l-5.271,5.271 c-0.195,0.195-0.195,0.512,0,0.707s0.512,0.195,0.707,0L43,23.707l5.271,5.271c0.195,0.195,0.512,0.195,0.707,0 s0.195-0.512,0-0.707L43.707,23l5.271-5.271c0.195-0.195,0.195-0.512,0-0.707s-0.512-0.195-0.707,0L43,22.293L37.729,17.021z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.e23b23015a840240f3b860d4ae863f60.svg";
export { ForwardRef as ReactComponent };